import { Chip, Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import Edicao from './Edicao'
import dayjs from 'dayjs'
import TimerIcon from '@mui/icons-material/Timer'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import PrimeTable from '../../../components/PrimeTable'

const ListaEspera = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const conclui = useCallback((idListaEspera) => {
    metodoPrograma('conclui', { idListaEspera }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setDados(null)
    setTela('lista')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlListaEspera" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlListaEspera"
              action="lista"
              rows={10}
              habSearch
              head={['Nome', 'Contato', 'Inclusão', 'Observação', 'Situação']}
              line={(item) => [
                item[1],
                item[2],
                item[4] ? dayjs(item[4]).format('DD/MM/YYYY HH:MM') : null,
                item[3],
                item[5] ? (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <Chip
                      onClick={() => conclui(item[0])}
                      label="Agendado"
                      color="success"
                      variant="outlined"
                      icon={<EventAvailableIcon />}
                    />
                  </div>
                ) : (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <Chip
                      onClick={() => conclui(item[0])}
                      label="Aguardando"
                      color="primary"
                      style={{ backgroundColor: 'red' }}
                      icon={<TimerIcon style={{ color: 'white' }} />}
                    />
                  </div>
                ),
              ]}
              collumnsDate={[2]}
              collumnsDateHour={[3]}
              onRowSelect={handleClick}
              refresh={refresh}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar }} />
      )}
    </Programa>
  )
}

export default ListaEspera
